'use strict';

angular.module('admin.article', [
    'ng-komondor-resource-view',
])

.config(function (resourceStateProvider)
{
    resourceStateProvider
    .state('admin.articles', {
        url: 'articles/{categoryId:[0-9\w-]+}',
        model: 'Article',
        viewOptions: 'articleViewOptions',
        title: 'Articles',
        modelNameField: 'title',
        edit: {
            templateUrl: 'admin/article/article.edit.html',
            controller: 'EditCtrl',
            defaults: {
                display_order: 1,
            }
        },
        root: {
            resolve: {
                viewOptions: [
                    'articleViewOptions',
                    '$stateParams',
                    'stateOptions',
                    'Category',
                    'Programme',
                    '$state',
                    function (viewOptions, $stateParams, stateOptions, Category, Programme, $state)
                    {
                        return Category.find($stateParams.categoryId).then(function (category)
                        {
                            return Programme.find(category.programme_id).then(function (programme)
                            {
                                if (category) {

                                    var breadcrumb = [];

                                    breadcrumb.push({
                                        name: 'Programmes',
                                        go: function ()
                                        {
                                            $state.go('admin.programmes');
                                        }
                                    });

                                    breadcrumb.push({
                                        name: programme.title,
                                        go: function ()
                                        {
                                            $state.go('admin.categories', {'programmeId' : programme.id});
                                        }
                                    });

                                    breadcrumb.push({
                                        name: category.title,
                                    });

                                    stateOptions.customBreadcrumb = breadcrumb;

                                    stateOptions.edit.defaults.category_id = category.id;
                                    viewOptions.queryDefaults.where.category_id = category.id;
                                }

                                return viewOptions;
                            });
                        });
                    }
                ]
            }
        }
    });
})

.factory('articleViewOptions', function (
    extendDeep,
    resourceViewOptions,
    listNameTemplate,
    gridThumbTemplate,
    gridNameTemplate
) {
    return extendDeep(angular.copy(resourceViewOptions), {
        with: [
            'category',
            'category.programme',
        ],
        queryDefaults: {
            sort: [
                ['category_id', 'ASC'],
                ['display_order', 'ASC']
            ],
        },
        list: {
            columns: [
                {
                    label: 'Title',
                    name: 'title',
                   // template: listNameTemplate('title', 'asset.links.thumb'),
                    sortable: true,
                },
                {
                    label: 'Display Order',
                    name: 'display_order',
                    sortable: true,
                },
                {
                    label: 'Article Pages',
                    template: '<a ui-sref="admin.article-pages({articleId: model.id})">Article Pages</a>',
                    sortable: false,
                },
                {
                    label: 'Last modified',
                    name: 'updated_at',
                    template: '<span class="no-wrap">{{ model.updated_at | date }}</span>',
                    sortable: true,
                },
            ],
        },
        grid: {
            fields: [
                {
                    template: gridThumbTemplate('asset.links.thumb'),
                },
                {
                    template: gridNameTemplate('name', 'type'),
                },
            ],
        },
        sorts: [
            {
                label: 'Display Order',
                sort: 'display_order asc'
            }
        ],
    });
});
